var React = require('react');

function ArrowDownInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"stroke":"#000"},React.createElement("g",null,React.createElement("g",null,[React.createElement("path",{"d":"M4.5 0L4.5 10.599","transform":"translate(-29 -138) translate(0 111) translate(30 27)","key":0}),React.createElement("path",{"d":"M2.5 4.5L6.5 9 2.5 13.5","transform":"translate(-29 -138) translate(0 111) translate(30 27) rotate(90 4.5 9)","key":1})])))));
}

ArrowDownInline.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = ArrowDownInline;

ArrowDownInline.default = ArrowDownInline;
